// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file crm/v1/contact_events.proto (package crm.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Contact } from "./contact_pb.js";
import { file_crm_v1_contact } from "./contact_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file crm/v1/contact_events.proto.
 */
export const file_crm_v1_contact_events: GenFile = /*@__PURE__*/
  fileDesc("Chtjcm0vdjEvY29udGFjdF9ldmVudHMucHJvdG8SBmNybS52MSKnAQoMQ29udGFjdEV2ZW50Ei4KB2NyZWF0ZWQYASABKAsyGy5jcm0udjEuQ29udGFjdENyZWF0ZWRFdmVudEgAEi4KB3VwZGF0ZWQYAiABKAsyGy5jcm0udjEuQ29udGFjdFVwZGF0ZWRFdmVudEgAEi4KB2RlbGV0ZWQYAyABKAsyGy5jcm0udjEuQ29udGFjdERlbGV0ZWRFdmVudEgAQgcKBWV2ZW50IjcKE0NvbnRhY3RDcmVhdGVkRXZlbnQSIAoHY29udGFjdBgBIAEoCzIPLmNybS52MS5Db250YWN0ImoKE0NvbnRhY3RVcGRhdGVkRXZlbnQSKQoQcHJldmlvdXNfY29udGFjdBgBIAEoCzIPLmNybS52MS5Db250YWN0EigKD3VwZGF0ZWRfY29udGFjdBgCIAEoCzIPLmNybS52MS5Db250YWN0IjcKE0NvbnRhY3REZWxldGVkRXZlbnQSIAoHY29udGFjdBgBIAEoCzIPLmNybS52MS5Db250YWN0QitaKXBhY2thZ2VzL2JhY2tlbmQtbW9kdWxlLWNybS9hcGkvdjE7Y3JtX3YxYghlZGl0aW9uc3DoBw", [file_crm_v1_contact]);

/**
 * @generated from message crm.v1.ContactEvent
 */
export type ContactEvent = Message<"crm.v1.ContactEvent"> & {
  /**
   * @generated from oneof crm.v1.ContactEvent.event
   */
  event: {
    /**
     * @generated from field: crm.v1.ContactCreatedEvent created = 1;
     */
    value: ContactCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: crm.v1.ContactUpdatedEvent updated = 2;
     */
    value: ContactUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: crm.v1.ContactDeletedEvent deleted = 3;
     */
    value: ContactDeletedEvent;
    case: "deleted";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message crm.v1.ContactEvent.
 * Use `create(ContactEventSchema)` to create a new message.
 */
export const ContactEventSchema: GenMessage<ContactEvent> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact_events, 0);

/**
 * @generated from message crm.v1.ContactCreatedEvent
 */
export type ContactCreatedEvent = Message<"crm.v1.ContactCreatedEvent"> & {
  /**
   * @generated from field: crm.v1.Contact contact = 1;
   */
  contact?: Contact;
};

/**
 * Describes the message crm.v1.ContactCreatedEvent.
 * Use `create(ContactCreatedEventSchema)` to create a new message.
 */
export const ContactCreatedEventSchema: GenMessage<ContactCreatedEvent> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact_events, 1);

/**
 * @generated from message crm.v1.ContactUpdatedEvent
 */
export type ContactUpdatedEvent = Message<"crm.v1.ContactUpdatedEvent"> & {
  /**
   * @generated from field: crm.v1.Contact previous_contact = 1;
   */
  previousContact?: Contact;

  /**
   * @generated from field: crm.v1.Contact updated_contact = 2;
   */
  updatedContact?: Contact;
};

/**
 * Describes the message crm.v1.ContactUpdatedEvent.
 * Use `create(ContactUpdatedEventSchema)` to create a new message.
 */
export const ContactUpdatedEventSchema: GenMessage<ContactUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact_events, 2);

/**
 * @generated from message crm.v1.ContactDeletedEvent
 */
export type ContactDeletedEvent = Message<"crm.v1.ContactDeletedEvent"> & {
  /**
   * @generated from field: crm.v1.Contact contact = 1;
   */
  contact?: Contact;
};

/**
 * Describes the message crm.v1.ContactDeletedEvent.
 * Use `create(ContactDeletedEventSchema)` to create a new message.
 */
export const ContactDeletedEventSchema: GenMessage<ContactDeletedEvent> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact_events, 3);

